import { TSimpleReviewCount } from '@/entities/room'

export const convertSimpleReviewCounts = (
  simpleReviewCounts: TSimpleReviewCount[],
) => {
  const hostSimpleReview: TSimpleReviewCount[] = []
  const roomSimpleReview: TSimpleReviewCount[] = []

  simpleReviewCounts.forEach(review => {
    if (review.count === 0) return

    if (review.isForHost) {
      hostSimpleReview.push(review)
    } else {
      roomSimpleReview.push(review)
    }
  })

  return { hostSimpleReview, roomSimpleReview }
}
